/**
 * @author Rajesh Bodapati
 * @email rajesh.bodapati@ul.com
 * @create date 2021-05-21 11:56:40
 * @modify date 2021-05-21 11:56:40
 * @desc [description]
 */
<template>
  <div id="RBACMrktPlaceServicesModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header modal-bgcolor">
          <button type="button" class="close" @click="cancelPermissions">
            &times;
          </button>
          <div class="modal-title">Master Services</div>
          <hr />
        </div>
        <div class="modal-body">
          <div class="col-md-10 col-sm-10 col-xs-11 bt-border ml-40">
            <div class="row">
              <div class="col-sm-8 col-xs-9 pd">Services access</div>
              <div class="col-sm-3 col-xs-2 txt-alg-rt">Permissions</div>
            </div>
          </div>
          <div
            v-for="(service, index) in servicesList"
            :key="index"
            class="col-md-10 col-sm-10 col-xs-11 bt-border ml-40"
          >
            <div class="row">
              <div class="col-sm-8 col-xs-9 pd">
                <div class="cust_label label-selected">{{ service.name }}</div>
              </div>
              <div class="col-sm-3 col-xs-2">
                <div
                  class="edit-lnk"
                  @click.stop.prevent="openPermissionsPopup(service)"
                >
                  edit
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 col-md-12 footer remove_button_padding">
          <div
            class="col-md-3 col-md-offset-8 col-sm-offset-8 col-xs-offset-6 col-sm-3 col-xs-5 xs-pd-lt-0"
          >
            <button
              type="button"
              class="btn btn-block emergo-white-button"
              @click="cancelPermissions"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
    <rbac-mrktplace-modules-modal
      :selectService="selectedService"
      @updatePermissions="updatePermissions"
    />
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import Loader from '../../UIComponents/Loader.vue';
import RBACMrktPlaceModulesModal from './RBACMrktPlaceModulesModal.vue';
import { getServicesListWithRBAC } from '../../../apis/marketPlace';

export default {
  components: {
    Loader,
    'rbac-mrktplace-modules-modal': RBACMrktPlaceModulesModal,
  },
  data() {
    return {
      servicesList: [], // list of services
      selectedService: '',
      loaderStatus: false,
    };
  },
  methods: {
    updatePermissions() {
      this.getListOfRoles();
    },
    openPermissionsPopup(service) {
      this.selectedService = cloneDeep(service.service);
      $('#rbacMrktPlaceModulesModal').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async getListOfRoles() {
      this.loaderStatus = true;
      this.servicesList = await getServicesListWithRBAC();
      this.loaderStatus = false;
    },
    cancelPermissions() {
      $('#RBACMrktPlaceServicesModal').modal('hide');
    },
  },
  mounted() {
    $('#RBACMrktPlaceServicesModal').on('shown.bs.modal', async () => {
      this.getListOfRoles();
    });
  },
};
</script>
<style scoped lang="scss">
$font-family-Roboto: Roboto;
$font-style-normal: normal;
.modal-header {
	padding: 15px 30px;
	&.modal-bgcolor {
		background-color: $deep-white;
		border: 0px;
		border-radius: $radius5;
		padding-bottom: 0px;
	}
	.close {
		background: none;
		opacity: 0.5;
		height: 17px;
    @include fontItems($font-38, 28px, $font-weight-small);
		color: $deep-gray;
		width: 17px;
		border-radius: 20px;
		outline: none;
		z-index: 1;
	}
}
.modal-title {
  font-family: $font-family-Roboto;
  font-style: $font-style-normal;
  font-weight: $font-weight-medium;
  font-size: $font-20;
  color: $primary;
}
.modal-body {
  padding: 0px 15px 15px 15px;
  height: 70vh;
  overflow: auto;
}
.label-selected{
  color: $primary;
  font-weight: $font-weight-medium;
}
.edit-lnk{
  font-family: $font-family-Roboto;
  font-style: $font-style-normal;
  @include fontItems($font-16, 37px, $font-weight-normal);
  text-align: right;
  padding-right: 35%;
  color: $messenger-blue;
  cursor: pointer;
}
.bt-border {
  border-bottom: 1px solid $gray74;
}
.cust_label {
  word-wrap: break-word !important;
  display: inline;
  margin-left: 10px;
  vertical-align: super;
  line-height: 37px;
  font-size: $font-14;
  font-weight: $font-weight-small;
}
.footer{
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.ml-40 {
  margin-left: 40px;
}
@media (min-width: 768px) and (max-width: 1024px){
    .modal-dialog {
      vertical-align: top;
    }
    .modal-body {
      height: 35vh;
      overflow: auto;
    }
}
@media screen and (max-width: 767px){
  .cust_label {
    font-size: 12px;
    margin-left: 2px;
  }
  .pd {
    padding: 0px 5px;
  }
}
@media screen and (max-width: 540px){
  .txt-alg-rt {
    padding: 0px;
  }
  .cust_label {
    margin-left: 2px;
  }
  .ml-40 {
    margin-left: 0px;
  }
}
</style>
